<template>
  <div>
    <v-autocomplete
      :class="{ 'pt-0': noStyle, 'mt-0': noStyle }"
      :label="$t('components.selectors.taskAssigneeSelector.assignee')"
      v-model="assigneeUsername"
      :items="assigneeOptions"
      :menu-props="{ maxHeight: '400' }"
      @input.native="loadAssignees($event, $data)"
      :search-input.sync="assigneeSearch"
      persistent-hint
      color="primary"
      clearable
      autocomplete="off"
      :disabled="disabled"
      item-text="username"
      return-object
    >
      <template v-slot:item="{ item }">
        {{ item.username }}
      </template>
      <template v-slot:selection="{ item }">
        {{ item.username }}
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import api from "@/utils/api";
import debounce from "@/plugins/debounce";

export default {
  props: {
    initialData: {
      type: Object,
      default: Object,
    },
    noStyle: {
      type: Boolean,
      default: false,
    },
    professional: {
      type: String,
      default: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    assigneeOptions: [],
    assigneeSearch: "",
  }),
  created() {
    if (
      Object.keys(this.initialData).length !== 0 &&
      typeof this.initialData.delete === "undefined"
    ) {
      if (typeof this.initialData.email !== "undefined") {
        this.initialData.username = this.initialData.email;
      }
      this.assigneeOptions.push(this.initialData);
      this.assigneeUsername = this.initialData;
    }
    this.loadAssignees(null, this);
  },

  computed: {
    assigneeUsername: {
      get: function () {
        return this.initialData;
      },
      set: function (value) {
        if (typeof value !== "undefined") {
          this.$emit("change", value);
        } else {
          this.$emit("change", { username: null });
        }
      },
    },
  },
  methods: {
    loadAssignees: function () {
      var self = this;
      self.assigneeSearch = self.assigneeSearch ? self.assigneeSearch : "";
      if (typeof this.professional !== "undefined") {
        api
          .taskAssigneeAutocomplete(self.professional, self.assigneeSearch)
          .then((resp) => {
            resp.data.results.forEach((element) => {
              if (
                !self.assigneeOptions.find(
                  (el) => el.username == element.username
                )
              ) {
                self.assigneeOptions.push(element);
              }
            });
          });
      }
    },
    debounceAssignees: debounce((event, self) => {
      this.loadAssignees();
    }, 300),
  },
};
</script>
